<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-05-17 14:42:07
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-29 13:48:25
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="contractNum">
            <el-input
              v-model="filterForm.contractNum"
              placeholder="合同编号"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="client"
            v-show="$route.query.$backPath != '/village/management/list'"
          >
            <el-input
              v-model="filterForm.client"
              placeholder="委托方"
              style="width: 260px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="trustee">
            <el-input
              v-model="filterForm.trustee"
              placeholder="被委托方"
              style="width: 260px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="statusFlag">
            <el-select
              v-model="filterForm.statusFlag"
              placeholder="合同状态"
              style="width: 150px"
            >
              <el-option label="全部" value="-1"></el-option>
              <el-option
                v-for="item in uniqeGlobalDict$$['10']"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro('filterForm')"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table :data="contracts" style="width: 100%">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractNum"
          label="合同编号"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="client"
          label="委托方"
          min-width="10%"
          v-if="$route.query.$backPath != '/village/management/list'"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="trustee"
          label="被委托方"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contractAllotted"
          label="合同期限"
          min-width="12%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusFlagName"
          label="合同状态"
          min-width="7%"
          align="center"
        >
        </el-table-column>

        <el-table-column label="操作" min-width="7%" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              round
              @click="handleLookDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
export default {
  $dictKeyList: [
    {
      key: '10',
      name: '托管合同状态',
    },
  ],
  data() {
    return {
      filterForm: {
        contractType: 2, //2 托管合同 3流转合同
        contractNum: '',
        client: '',
        trustee: '',
        statusFlag: '',
        clientAccountId: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      contracts: [],
    }
  },
  created() {
    this.filterForm.clientAccountId = this.$route.query.$businessAccountId
    this.getContractList()
  },
  methods: {
    /**
     * @descripttion: 获取合同列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 20:35:33
     * @param {*}
     * @return {*}
     */
    getContractList() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.statusFlag == -1) {
        delete this.allFilters.statusFlag
      }
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.contract.getContractList(params).then((res) => {
        let { recordTotal, content: contracts } = res.data
        this.pagination.recordTotal = recordTotal
        this.contracts = contracts
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getContractList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-24 14:05:16
     * @param {*} params
     * @return {*}
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/village/trustee/contract/detail',
        query: { id: params.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .btn-panle {
    margin-top: 10px;
  }
  .el-table {
    margin-top: 6px;
  }
}
</style>
